// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pro-badge[data-v-242d9b74]{border-radius:4px;display:block;padding:0 12px}.asa-icon[data-v-242d9b74]{vertical-align:text-top}.photo-overlay[data-v-242d9b74]{align-items:center;background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.6));bottom:0;position:absolute;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
